import type { IconProps } from '../types/IconProps.ts';
export const Nut: IconProps = {
    name: 'Nut',
    children: [
        `<path d="M5 10c0 3.2 1.53 6.22 4.1 8.1l2.9 2.11M19 10c0 3.2-1.53 6.22-4.1 8.1L12 20.21m0 0V21M12 3v1m0 0H8a5 5 0 0 0-5 5v.27c0 .36.35.61.7.5L6 9q0 0 0 0l2 1q0 0 0 0l2-1q0 0 0 0l2 1q0 0 0 0l2-1q0 0 0 0l2 1q0 0 0 0l2-1q0 0 0 0l2.3.77c.35.11.7-.14.7-.5V9a5 5 0 0 0-5-5z" />`,
    ]
};